export default "__VITE_ASSET__b7b35481__"